export default {
  3: 'Ropsten',
  4: 'Rinkeby',
  42: 'Kovan',
  5777: 'Local',
}
